<template>
<div class="custom-block tip">
    <p class="custom-block-title">Mensajería hacia el core bancario</p>
    <p>
        Para más información sobre la mensajería hacia el core bancario, consultar la documentación 
        <a href="/apis/mensajeriat1json/" class="">Mensajería T1JSON</a>
    </p>
</div>
</template>
<script>
export default {
    name: 'Mensajeriat1json'
}
</script>